import { lighterGrey } from "constants/colors";
import styled from "styled-components/macro";
import { AHEAD_BEHIND_TILE_HEIGHT } from "../aheadBehindUtils";

const WIDTH = 41;

/** Empty grey bar */
export default styled.div`
  background: ${lighterGrey};
  border-radius: 4px;
  width: ${WIDTH}px;
  height: ${AHEAD_BEHIND_TILE_HEIGHT}px;
  margin-right: 4px;
`;
